import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2c66caa1 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _78327518 = () => interopDefault(import('..\\pages\\hub\\index.vue' /* webpackChunkName: "pages_hub_index" */))
const _fa72c438 = () => interopDefault(import('..\\pages\\patient\\index.vue' /* webpackChunkName: "pages_patient_index" */))
const _a4b25e74 = () => interopDefault(import('..\\pages\\print.vue' /* webpackChunkName: "pages_print" */))
const _35a3b3a2 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _6359f40a = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _e04076fc = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _e02447fa = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _dfebe9f6 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _dfcfbaf4 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _7674007a = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _0954347f = () => interopDefault(import('..\\pages\\hub\\have-a-card\\index.vue' /* webpackChunkName: "pages_hub_have-a-card_index" */))
const _c008dbe2 = () => interopDefault(import('..\\pages\\patient\\have-a-card\\index.vue' /* webpackChunkName: "pages_patient_have-a-card_index" */))
const _be6e140c = () => interopDefault(import('..\\pages\\hub\\have-a-card\\eligibility.vue' /* webpackChunkName: "pages_hub_have-a-card_eligibility" */))
const _e22d875e = () => interopDefault(import('..\\pages\\hub\\have-a-card\\patient-information.vue' /* webpackChunkName: "pages_hub_have-a-card_patient-information" */))
const _af3dcc20 = () => interopDefault(import('..\\pages\\hub\\have-a-card\\success.vue' /* webpackChunkName: "pages_hub_have-a-card_success" */))
const _f156d9b0 = () => interopDefault(import('..\\pages\\hub\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_hub_need-a-card_eligibility" */))
const _56d3cb7f = () => interopDefault(import('..\\pages\\hub\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_hub_need-a-card_patient-information" */))
const _849303c4 = () => interopDefault(import('..\\pages\\hub\\need-a-card\\success.vue' /* webpackChunkName: "pages_hub_need-a-card_success" */))
const _799030ec = () => interopDefault(import('..\\pages\\patient\\have-a-card\\eligibility.vue' /* webpackChunkName: "pages_patient_have-a-card_eligibility" */))
const _36559de1 = () => interopDefault(import('..\\pages\\patient\\have-a-card\\patient-information.vue' /* webpackChunkName: "pages_patient_have-a-card_patient-information" */))
const _32a75380 = () => interopDefault(import('..\\pages\\patient\\have-a-card\\success.vue' /* webpackChunkName: "pages_patient_have-a-card_success" */))
const _ac78f690 = () => interopDefault(import('..\\pages\\patient\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_patient_need-a-card_eligibility" */))
const _037fa5e2 = () => interopDefault(import('..\\pages\\patient\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_patient_need-a-card_patient-information" */))
const _47fcb7ae = () => interopDefault(import('..\\pages\\patient\\need-a-card\\success.vue' /* webpackChunkName: "pages_patient_need-a-card_success" */))
const _2ebea72a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _2c66caa1,
    name: "error"
  }, {
    path: "/hub",
    component: _78327518,
    name: "hub"
  }, {
    path: "/patient",
    component: _fa72c438,
    name: "patient"
  }, {
    path: "/print",
    component: _a4b25e74,
    name: "print"
  }, {
    path: "/rejection",
    component: _35a3b3a2,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _6359f40a,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _e04076fc,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _e02447fa,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _dfebe9f6,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _dfcfbaf4,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _7674007a,
    name: "errors-500"
  }, {
    path: "/hub/have-a-card",
    component: _0954347f,
    name: "hub-have-a-card"
  }, {
    path: "/patient/have-a-card",
    component: _c008dbe2,
    name: "patient-have-a-card"
  }, {
    path: "/hub/have-a-card/eligibility",
    component: _be6e140c,
    name: "hub-have-a-card-eligibility"
  }, {
    path: "/hub/have-a-card/patient-information",
    component: _e22d875e,
    name: "hub-have-a-card-patient-information"
  }, {
    path: "/hub/have-a-card/success",
    component: _af3dcc20,
    name: "hub-have-a-card-success"
  }, {
    path: "/hub/need-a-card/eligibility",
    component: _f156d9b0,
    name: "hub-need-a-card-eligibility"
  }, {
    path: "/hub/need-a-card/patient-information",
    component: _56d3cb7f,
    name: "hub-need-a-card-patient-information"
  }, {
    path: "/hub/need-a-card/success",
    component: _849303c4,
    name: "hub-need-a-card-success"
  }, {
    path: "/patient/have-a-card/eligibility",
    component: _799030ec,
    name: "patient-have-a-card-eligibility"
  }, {
    path: "/patient/have-a-card/patient-information",
    component: _36559de1,
    name: "patient-have-a-card-patient-information"
  }, {
    path: "/patient/have-a-card/success",
    component: _32a75380,
    name: "patient-have-a-card-success"
  }, {
    path: "/patient/need-a-card/eligibility",
    component: _ac78f690,
    name: "patient-need-a-card-eligibility"
  }, {
    path: "/patient/need-a-card/patient-information",
    component: _037fa5e2,
    name: "patient-need-a-card-patient-information"
  }, {
    path: "/patient/need-a-card/success",
    component: _47fcb7ae,
    name: "patient-need-a-card-success"
  }, {
    path: "/",
    component: _2ebea72a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
